module.exports = __webpack_public_path__ + "static/media/zillow-header.19ef0edf.png";